import React, { useState } from "react";

import { RxHamburgerMenu, RxExit } from "react-icons/rx";

import { BsFillPersonFill, BsSearch } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { selectUserData } from "../features/store";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { ListItemIcon } from "@mui/material";
import { logOut } from "../features/slices/userDataSlice";
import { setOpenVerticalNavBar } from "../features/slices/uiControlSlice";
import { AiOutlineCompass } from "react-icons/ai";
export const TopNavBar = ({ shadow, buildingDict, selectedBuilding, setSelectedBuilding, hideDropDown }) => {
    const userData = useSelector(selectUserData);
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorBuildingSelect, setAnchorBuildingSelect] = useState(null);
    const open = Boolean(anchorEl);
    const openBuilding = Boolean(anchorBuildingSelect);
    const [searchBuilding, setSearchBuilding] = useState("");
    function signOut() {
        console.log("ACCOUNT ACTION | Log Out");
        setAnchorEl(null);
        localStorage.removeItem("token");
        dispatch(logOut());
    }
    function openVerticalNav() {
        dispatch(setOpenVerticalNavBar(true));
    }
    return (
        <div className={`veryTop ${shadow && "shadow"}`}>
            <div className="smallScreenNavBar">
                <RxHamburgerMenu onClick={() => openVerticalNav()} />
            </div>
            <div className="building-select-wrapper">
                <img src="/cbm_720.png" alt="image" width={"60"} />
                {!hideDropDown && buildingDict && (
                    <div
                        className={"building-select"}
                        onClick={(event) => {
                            if (Object.keys(buildingDict).length > 0) {
                                setAnchorBuildingSelect(event.currentTarget);
                            }
                        }}
                    >
                        <div className="display">
                            {buildingDict[selectedBuilding]
                                ? buildingDict[selectedBuilding].buildingName
                                : "No Room Available"}
                        </div>
                        <div
                            className="triangle"
                            style={openBuilding ? { transform: "rotate(0deg)" } : { transform: "rotate(180deg)" }}
                        ></div>
                    </div>
                )}
            </div>

            <div
                className="accountBlock"
                onClick={(event) => {
                    setAnchorEl(event.currentTarget);
                }}
            >
                <div className="account">
                    <BsFillPersonFill size={"80%"} color="gray" />
                </div>
                <div className="accountName">{userData.username}</div>
                <div
                    className="triangle"
                    style={open ? { transform: "rotate(0deg)" } : { transform: "rotate(180deg)" }}
                ></div>
            </div>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => {
                    setAnchorEl(null);
                }}
            >
                <MenuItem onClick={signOut}>
                    <ListItemIcon>
                        <RxExit />
                    </ListItemIcon>
                    <p>Log Out</p>
                </MenuItem>
            </Menu>

            <Menu
                id="basic-menu"
                anchorEl={anchorBuildingSelect}
                open={openBuilding}
                onClose={() => {
                    setSearchBuilding("");
                    setAnchorBuildingSelect(null);
                }}
            >
                <div className="building-select-panel">
                    <div className="building-select-panel-search">
                        <BsSearch />
                        <input
                            onKeyDown={(e) => e.stopPropagation()}
                            type="text"
                            onChange={(e) => {
                                setSearchBuilding(e.target.value);
                            }}
                            value={searchBuilding}
                        />
                    </div>
                    <div className="panel-content">
                        <div className="building-options">
                            {!hideDropDown &&
                                buildingDict &&
                                Object.keys(buildingDict)
                                    .filter((bid) => {
                                        return buildingDict[bid].buildingName.startsWith(searchBuilding);
                                    })
                                    .sort((a, b) => {
                                        if (a === "all") return -1;
                                        if (b === "all") return 1;
                                        return buildingDict[a].buildingName.localeCompare(buildingDict[b].buildingName);
                                    })
                                    .map((bid, i) => {
                                        return (
                                            <BuildingOption
                                                key={"buildingOption" + i}
                                                display={buildingDict[bid].buildingName}
                                                setSelected={() => {
                                                    setSelectedBuilding(bid);
                                                    setAnchorBuildingSelect(null);
                                                    localStorage.setItem("selectedBuilding", bid);
                                                }}
                                                isSelected={bid === selectedBuilding}
                                            />
                                        );
                                    })}
                        </div>
                    </div>
                </div>
            </Menu>
        </div>
    );
};

export const TopBanner = ({ title, children, navigator }) => {
    return (
        <div className="top-banner">
            <div className="top-banner-title-row">
                <h1 className="top-banner-title">{title}</h1>
                {navigator}
            </div>
            {children}
        </div>
    );
};

const BuildingOption = ({ display, setSelected, isSelected }) => {
    return (
        <div className={`building-option ${isSelected && "selected"}`} onClick={setSelected}>
            <p>{display}</p>
        </div>
    );
};

export const Navigator = ({ refs, names }) => {
    const executeScroll = (ref) => ref.current.scrollIntoView({ behavior: "smooth" });

    return (
        <div className="navigator">
            <div className="nav-header">
                <AiOutlineCompass className="compass" />
                <p className="on-this-page">On this page:</p>
            </div>

            <div className="navs">
                {refs.map((ref, i) => {
                    return (
                        <p onClick={() => executeScroll(ref)} key={i}>
                            {names[i]}
                        </p>
                    );
                })}
            </div>
        </div>
    );
};
